// extracted by mini-css-extract-plugin
export default {"prefModal_scroll":"SleneRadios_prefModal_scroll__t12lr"};